import React from 'react';
import { DModal } from './d-modal';
import { Box, Button, Typography } from '@mui/material';

interface ICustomConfirmationModal {
    open: boolean;
    setOpen: (open: boolean) => void;
    callback: (() => void) | (() => Promise<void>);
    // All optional so existing delete confirmations keep their current copy.
    // Override them to reuse this dialog for non-delete confirmations (e.g.
    // logout) without a bespoke modal.
    title?: string;
    message?: string;
    confirmLabel?: string;
    confirmColor?: 'primary' | 'error';
    cancelLabel?: string;
    // Sizing and header colour are pass-throughs, defaulted to what this modal
    // has always rendered, so the delete confirmations that share it are
    // unaffected. Override them when the confirmation opens ON TOP of another
    // modal — inheriting DModal's 'xl' width there makes the two dialogs the
    // same size and the second one stops reading as a separate question.
    size?: 'xl' | 'large' | 'medium' | 'small';
    tight?: boolean;
    height?: string;
    toolbarColor?: 'primary' | 'warning';
}

export function DConfirmationModal({
    open,
    setOpen,
    callback,
    title = 'Confirmacion',
    message = '¿Estas seguro que quieres borrar esta entidad?',
    confirmLabel = 'Confirmar',
    confirmColor,
    cancelLabel,
    size,
    tight,
    height = '10rem',
    toolbarColor,
}: ICustomConfirmationModal) {
    return (
        <DModal
            open={open}
            setOpen={setOpen}
            title={title}
            height={height}
            size={size}
            tight={tight}
            toolbarColor={toolbarColor}
        >
            <Box
                sx={{
                    flex: 1,
                    p: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'stretch',
                }}
            >
                <Typography>{message}</Typography>
                {/* Pushes the buttons to the bottom of a fixed-height modal.
                    minHeight is the floor for a modal sized to its content
                    (height="auto"), where there is no free space to distribute
                    and the buttons would otherwise sit flush against the text.
                    Fixed-height callers already have more room than this, so
                    nothing moves for them. */}
                <Box sx={{ flex: 1, minHeight: 16 }} />
                <Box
                    sx={{
                        alignSelf: 'flex-end',
                        display: 'flex',
                        gap: 1,
                    }}
                >
                    {cancelLabel ? (
                        <Button
                            variant={'text'}
                            type={'button'}
                            onClick={() => setOpen(false)}
                        >
                            {cancelLabel}
                        </Button>
                    ) : null}
                    <Button
                        variant={'outlined'}
                        color={confirmColor}
                        type={'button'}
                        onClick={callback}
                    >
                        {confirmLabel}
                    </Button>
                </Box>
            </Box>
        </DModal>
    );
}
